import { render, staticRenderFns } from "./ShowDetails.vue?vue&type=template&id=fabd6eee&scoped=true&"
import script from "./ShowDetails.vue?vue&type=script&lang=js&"
export * from "./ShowDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShowDetails.vue?vue&type=style&index=0&id=fabd6eee&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabd6eee",
  null
  
)

export default component.exports